const getName = (parent, field_label) =>
  parent ? `${parent}.fields.${field_label}` : field_label;

export function removeLabelCharacter(label){
  if (label) {
   return label?.trim()?.replace(/\./g, '');
  }
  return label;
}
export default getName;
